import React from "react";
import { useNavigate } from "react-router-dom";

import '../css/GameType.scss';

export default function GameType() {
    const navigate = useNavigate();

    const goToGame = (event) => {
        const value = event.target.value;

        console.log('go to game', value);
        navigate(`/table`, {
            state:{
                game: value
            }
        });
    }

    return (
        <div className="game-type-container flex-container column-flex start">
            <p className="game-type-label">Game Type:</p>
            <select className="game-type" name="game_type" onChange={goToGame}>
                <option value="war">War</option>
                <option value="3 card">3 Card</option>
                <option value="5 card">5 Card</option>
            </select>
        </div>
    )
}